import { SupabaseClient, User } from "@supabase/supabase-js";
import { supabase, supabaseAdmin } from "../../config/supabaseClient";
import { BROWSABLE_WWW_ORIGIN } from "../../config/brand";
import axios from "axios";
import { checkTestEmail, isStripeTestModeSync } from "../StripeTestMode";
import { StaticVariables } from "../StaticVariables";
import { calculateSeatTotals } from "../seatUtils";
import { markLinkInBioContentEdited } from "../../Screens/DashboardView/GettingStarted/gettingStartedProgress";
import { websiteDemoOnboardPatch } from "../isInternalStaffEmail";

function getAuthRedirectOrigin(): string {
  // Use the current app origin in the browser (localhost, staging domains, etc.)
  // so Supabase Auth redirects land back in the same environment.
  try {
    const origin = BROWSABLE_WWW_ORIGIN;
    return String(BROWSABLE_WWW_ORIGIN);
  } catch (_e) {
    return String(BROWSABLE_WWW_ORIGIN);
  }
}

export async function signUpEmail(email: any, password: any) {
  var { data, error }: any = await supabase.auth.signUp({
    email: email,
    password: password,
  });
  if (error) {
    return false;
  } else if (data) {
    localStorage.setItem("emailCredentials", email);
    return email;
  }
}
export async function loginEmail(email: any, password: any) {
  const { data, error } = await supabase.auth.signInWithPassword({
    email: email,
    password: password,
  });
  if (data.user) {
    const { data: userData } = await supabase
      .from("user")
      .select("username, is_first_redirect, onboarding_step, is_first_login")
      .eq("email", email)
      .single();

    if (userData) {
      const username = userData.username;
      localStorage.setItem("loggedIn", username);

      // IMPORTANT: Keep behavior consistent with `src/Screens/Auth/LoginAuth/Login.tsx`
      // so dashboard bootstraps correctly on first navigation.
      try {
        const { data: fullUserRow } = await supabase
          .from("user")
          .select("*")
          .eq("email", email)
          .single();
        if (fullUserRow) {
          localStorage.setItem("member", JSON.stringify(fullUserRow));
        }
      } catch (_e) {
        // non-blocking
      }
      try {
        window.dispatchEvent(new Event("memberLogin"));
      } catch (_e) {
        // ignore
      }

      // Check if user is coming from onboarding (onboarding_step === 4)
      const isFromOnboarding = userData.onboarding_step === 4;

      if (isFromOnboarding) {
        // If coming from onboarding, set is_first_redirect to true and is_first_login to false
        await supabase
          .from("user")
          .update({
            is_first_redirect: true,
          })
          .eq("username", username);

        return {
          username,
          isFirstRedirect: true,
          isFirstLogin: false,
        };
      } else {
        // If coming from login route
        const isFirstLogin =
          userData.is_first_login === null ||
          userData.is_first_login === undefined;

        // NOTE:
        // We do NOT mutate `is_first_login` here anymore.
        // `is_first_login` is now reserved for the Welcome Tour completion flag and is written
        // only after the tour is completed in the dashboard.

        return {
          username,
          isFirstRedirect:
            !userData.is_first_redirect || userData.onboarding_step < 4,
          isFirstLogin: isFirstLogin,
        };
      }
    }
    return false;
  } else if (error) {
    return "error";
  }
}

export async function signupUser(
  username: string,
  fullName: any,
  instagramHandle: string,
  youtubeChannelId: any,
  tiktokUsername: any,
  podcastShowLink: any,
  firstPlatform: any,
  // email: string,
  phoneNumber: any,
  user: User
) {
  const res = {
    error: false,
    message: "Error, please try again later or contact our support team.",
  };
  let createNewUserError;
  const slackToken =
    "xoxb-4117828880165-5021374947286-Srzu3WPZg8n26bq5gHCrjaGX";
  const channel = "#newcreators";
  try {
    if (!username || !fullName || !phoneNumber) {
      res.error = true;
      res.message = "Please fill in all fields";
      return res;
    } else {
    }
    if (!user) {
      const {
        data: { user: sessionUser },
      } = await supabase.auth.getUser();
      if (!sessionUser) {
        res.error = true;
        return res;
      }
      user = sessionUser;
    }
    // const name = firstName + " " + lastName;
    const staffWebsiteDemo = websiteDemoOnboardPatch(String(user.email || ""));
    if (firstPlatform === "Instagram") {
      const { error } = await supabase.from("user").insert([
        {
          name: fullName,
          username,
          user_id: user.id,
          instagram_username: instagramHandle,
          first_connected_platform: firstPlatform,
          phoneNo: phoneNumber,
          email: user.email,
          ...staffWebsiteDemo,
        },
      ]);

      storeControlsAndTable(user.id, username, firstPlatform);
      try {
        const url = `https://dev.thesearchbubble.com/slack/update`;

        const resServer = await axios.post(
          url,
          {
            userId: user.id,
            user: username,
            channel: channel,
            msg: `New user signed up
        userrname :- ${username},
        platform :- ${firstPlatform},
        phoneNumber :-${phoneNumber},
        name :- ${fullName},
        instagram handle :- ${instagramHandle}
        USer id :- ${user.id}`,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const { success, message } = resServer.data;
      } catch (error) { }
      createNewUserError = error;
    } else if (firstPlatform === "Youtube") {
      const { error } = await supabase.from("user").insert([
        {
          name: fullName,
          username,
          user_id: user.id,
          youtube_channel_id: youtubeChannelId,
          first_connected_platform: firstPlatform,
          phoneNo: phoneNumber,
          email: user.email,
          ...staffWebsiteDemo,
        },
      ]);
      // await supabase
      //   .from("user")
      //   .update({ show_youtube: false, is_youtube_on: true })
      //   .eq("user_id", user.id);
      storeControlsAndTable(user.id, username, firstPlatform);

      createNewUserError = error;
      try {
        const url = `https://dev.thesearchbubble.com/slack/update`;

        const resServer = await axios.post(
          url,
          {
            userId: user.id,
            user: username,
            channel: channel,
            msg: `New user signed up
            userrname :- ${username},
            platform :- ${firstPlatform},
            phoneNumber :-${phoneNumber},
            name :- ${fullName},
            youtube channel id :- ${youtubeChannelId}
            USer id :- ${user.id}`,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const { success, message } = resServer.data;
      } catch (error) { }
    } else if (firstPlatform === "Podcast") {
      const regex = /\/show\/(\w+)\?/;

      // Use the regex to extract the show ID
      const match = podcastShowLink?.match(regex);

      // Check if there's a match and get the show ID
      const showId = match ? match[1] : "";
      const { error } = await supabase.from("user").insert([
        {
          name: fullName,
          username,
          user_id: user.id,
          podcast_link: podcastShowLink,
          podcast_id: showId,
          first_connected_platform: firstPlatform,
          phoneNo: phoneNumber,
          email: user.email,
          ...staffWebsiteDemo,
        },
      ]);
      await supabase
        .from("user")
        .update({ show_podcast: false, is_podcast_on: true })
        .eq("user_id", user.id);
      storeControlsAndTable(user.id, username, firstPlatform);

      createNewUserError = error;

      try {
        const url = `https://dev.thesearchbubble.com/slack/update`;

        const resServer = await axios.post(
          url,
          {
            userId: user.id,
            user: username,
            channel: channel,
            msg: `New user signed up
            userrname :- ${username},
            platform :- ${firstPlatform},
            phoneNumber :-${phoneNumber},
            name :- ${fullName},
            podcast show link :- ${podcastShowLink},
            podcast id :- ${showId}

            USer id :- ${user.id}`,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const { success, message } = resServer.data;
      } catch (error) { }
    } else if (firstPlatform === "Tiktok") {
      const { error } = await supabase.from("user").insert([
        {
          name: fullName,
          username,
          user_id: user.id,
          tiktok_user: tiktokUsername,
          first_connected_platform: firstPlatform,
          phoneNo: phoneNumber,
          email: user.email,
          ...staffWebsiteDemo,
        },
      ]);
      await supabase
        .from("user")
        .update({ show_tiktok: false, is_tiktok_on: true })
        .eq("user_id", user.id);
      storeControlsAndTable(user.id, username, firstPlatform);

      createNewUserError = error;
      try {
        const url = `https://dev.thesearchbubble.com/slack/update`;

        const resServer = await axios.post(
          url,
          {
            userId: user.id,
            user: username,
            channel: channel,
            msg: `New user signed up
            userrname :- ${username},
            platform :- ${firstPlatform},
            phoneNumber :-${phoneNumber},
            email :- ${user.email}
            name :- ${fullName},
            tiktok username :- ${tiktokUsername}
            USer id :- ${user.id}`,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const { success, message } = resServer.data;
      } catch (error) { }
    }

    if (createNewUserError) {
      res.error = true;
      if (
        createNewUserError.message ===
        'duplicate key value violates unique constraint "user_email_key"'
      ) {
        res.message = "This email is already in use.";
      }
      if (
        createNewUserError.message ===
        'duplicate key value violates unique constraint "user_username_key"'
      ) {
        res.message = "This username is already taken. Please try another one.";
      }
      return res;
    }

    // TODO - for now we just insert email to our table, future work: add the following lines of code to register the email in the auth.user supabase table. This will be done after a user clicks on "verify email" button
    // const { data, error } = await supabase.
    // 	email,
    // });
    await supabase.auth.updateUser({
      data: { username, currentOnboardingStep: 3 },
    });
    localStorage.setItem("loggedIn", username);

    return res;
  } catch (error: any) {
    res.error = true;
    res.message =
      error?.message ||
      "Error while creating user, please report this error to our support team.";
    return res;
  }
}
async function storeControlsAndTable(
  user_id: any,
  username: any,
  platform: any
) {
  await supabase
    .from("controls")
    .insert([
      {
        user_id: user_id,
        show_caption: "true",
        showCreatorCaption: "true",
        maxCreatorHashtag: 20,
        totalHashtagNum: 20,
        maxHashtag: 20,
        totalRecentSearches: "20",
        totalPopularSearches: "20",
        popularSearchesNumFollower: "20",
        popularSearchesNumCreator: "20",
        recentSearchesNumFollower: "20",
        recentSearchesNumCreator: "20",
        recent_searches: false,
        popular_searches: false,
        popularSearchesCreator: false,

        showCreatorFilters: false,
        showFollowerFilters: false,
        showAdsCreator: false,
        showAdsFollower: false,
        show_creator_comments: false,
        show_follower_comments: false,
      },
    ])
    .single();
  await supabase
    .from("controls_live")
    .insert([
      {
        user_id: user_id,
        show_caption: "true",
        totalHashtagNum: 20,
        maxHashtag: 20,
        totalRecentSearches: "20",
        totalPopularSearches: "20",
        popularSearchesNumFollower: "20",
        recentSearchesNumFollower: "20",
        recent_searches: false,
        popular_searches: false,
        username: username,

        showFollowerFilters: false,
        showAdsFollower: false,
        show_follower_comments: false,
        initial_content2: platform === "Instagram" ? "All" : "All",
      },
    ])
    .single();
  await supabase
    .from("controls_staging")
    .insert([
      {
        user_id: user_id,
        showCreatorCaption: "true",
        maxCreatorHashtag: 20,
        totalHashtagNum: 20,
        totalRecentSearches: "20",
        totalPopularSearches: "20",
        popularSearchesNumCreator: "20",
        recentSearchesNumCreator: "20",

        popularSearchesCreator: false,

        showCreatorFilters: false,
        showAdsCreator: false,
        show_creator_comments: false,
        initial_content2: platform === "Instagram" ? "All" : "All",
      },
    ])
    .single();
  // Create webhook tracking row for this user (all webhooks default false)
  try {
    const { error: webhookTrackingError } = await supabase
      .from("user_webhook_tracking")
      .upsert(
        {
          user_id: user_id,
          username: username,
        },
        { onConflict: "user_id", ignoreDuplicates: true }
      );
    if (webhookTrackingError) {
      console.error(
        "Failed to create user_webhook_tracking row:",
        webhookTrackingError.message
      );
    }
  } catch (webhookErr) {
    console.error("Unexpected error creating user_webhook_tracking row:", webhookErr);
  }
  const url = `https://dev.thesearchbubble.com/createTable`;
  await axios.post(url, {
    id: user_id,
    user: username,
  });
}
export async function storeUserDetails(
  provider_token: any,
  picture: any,
  provider_id: any,
  username: any,
  instagramId: any,
  auth_user_id: any
) {
  const response = await fetch(picture);

  const blob = await response.blob();

  if (
    blob.type === "image/jpeg" ||
    blob.type === "image/png" ||
    blob.type === "image/webp"
  ) {
    const mediaExt = blob.type.split("/")[1];

    await supabase.storage
      .from("profile-picture")
      .upload(`${username}.${mediaExt}`, blob, {
        contentType: blob.type,
      });

    const { data: image } = await supabase.storage
      .from("profile-picture")
      .getPublicUrl(`${username}.${mediaExt}`);

    await supabase
      .from("user")
      .update({
        provider_token,
        picture,
        provider_id,
        instagramId,
        storage_url: image?.publicUrl ? image.publicUrl : picture,
      })
      .eq("user_id", auth_user_id);
  }
}

export async function signUpPhone(phoneNumber: any) {
  const { data, error } = await supabase.auth.signInWithOtp({
    phone: phoneNumber,
  });

  if (error === null) {
    return true;
  } else {
    return false;
  }
}
export async function signInEmailOTP(emailId: any) {
  // const { data, error } = await supabase.auth.signInWithOtp({
  //   phone: phoneNumber,
  // });
  let loginError: any;
  const { data: login, error: errorLogin } = await supabase
    .from("user")
    .select("*")
    .eq("email", emailId);
  if (login) {
    if (login.length !== 0) {
      const { data, error } = await supabase.auth.signInWithOtp({
        email: emailId,
      });
      loginError = error;
    }
  }
  if (loginError === null) {
    return true;
  } else {
    if (loginError.includes("60 seconds")) {
      return "time error";
    } else {
      return false;
    }
  }
}
export async function signUpEmailOTP(emailId: any) {
  // const { data, error } = await supabase.auth.signInWithOtp({
  //   phone: phoneNumber,
  // });
  let signupError;
  const { data: signup, error: errorsignup } = await supabase
    .from("user")
    .select("*")
    .eq("email", emailId);
  if (signup) {
    if (signup.length === 0) {
      const { data, error } = await supabase.auth.signInWithOtp({
        email: emailId,
      });
      signupError = error;
    } else {
    }
  }
  if (signupError === null) {
    return true;
  } else {
    return false;
  }
}
export async function loginPhone(phoneNumber: any) {
  const { data, error } = await supabase.auth.signInWithOtp({
    phone: phoneNumber,
  });

  if (error === null) {
    return true;
  } else {
    return false;
  }
}
export async function verifyPhoneNumberSignUp(
  phnWithCode: any,
  token: any,
  moveToNextStep: (nextStep: number) => void
) {
  const res = {
    error: false,
    message: "",
  };

  const { data: sessionData, error } = await supabase.auth.verifyOtp({
    phone: phnWithCode,
    token,
    type: "sms",
  });
  if (error || !sessionData || !sessionData.user || !sessionData.user.id) {
    res.error = true;
    res.message = "Invalid token";
    return res;
  } else {
    localStorage.setItem("phoneCredentials", phnWithCode);
    // check user is already stored
    const { data }: any = await supabase
      .from("user")
      .select("*")
      .eq("user_id", sessionData.user.id)
      .single();
    if (data) {
      if (data.is_active) {
        await supabase.auth.updateUser({
          data: {
            username: data.username,
            currentOnboardingStep: 3,
            isOnboardingFinished: true,
          },
        });
        moveToNextStep(4);
        return res;
      }

      if (data.username && data.phoneNo) {
        await supabase.auth.updateUser({
          data: {
            username: data.username,
            currentOnboardingStep: 3,
            isOnboardingFinished: false,
          },
        });
        moveToNextStep(3);
        return res;
      }
    }

    // if the phone number is not registered, we continue with the onboarding flow
    await supabase.auth.updateUser({
      data: { currentOnboardingStep: 2, isOnboardingFinished: false },
    });
    moveToNextStep(2);
    return res;
  }
}

export async function verifyEmailSignUp(
  email: any,
  token: any,
  moveToNextStep: (nextStep: number) => void
) {
  const res = {
    error: false,
    message: "",
  };

  // const { data: sessionData, error } = await supabase.auth.verifyOtp({
  //   phone: phnWithCode,
  //   token,
  //   type: "sms",
  // });

  const { data: sessionData, error } = await supabase.auth.verifyOtp({
    email,
    token,
    type: "email",
  });
  if (error || !sessionData || !sessionData.user || !sessionData.user.id) {
    res.error = true;
    res.message = "Invalid token";
    return res;
  } else {
    localStorage.setItem("phoneCredentials", email);
    // check user is already stored
    const { data }: any = await supabase
      .from("user")
      .select("*")
      .eq("user_id", sessionData.user.id)
      .single();

    if (data) {
      if (data.is_active) {
        await supabase.auth.updateUser({
          data: {
            username: data.username,
            currentOnboardingStep: 3,
            isOnboardingFinished: true,
          },
        });
        moveToNextStep(4);
        return res;
      }

      if (data.username && data.email) {
        await supabase.auth.updateUser({
          data: {
            username: data.username,
            currentOnboardingStep: 3,
            isOnboardingFinished: false,
          },
        });
        moveToNextStep(3);
        return res;
      }
    }

    // if the phone number is not registered, we continue with the onboarding flow
    await supabase.auth.updateUser({
      data: { currentOnboardingStep: 2, isOnboardingFinished: false },
    });
    moveToNextStep(2);
    return res;
  }
}

export async function verifyPhoneNumberSignIn(
  phnWithCode: any,
  token: any,
  loginSuccess: (username: string) => void
) {
  const res = {
    error: false,
    message: "",
  };

  const { data: sessionData, error } = await supabase.auth.verifyOtp({
    phone: phnWithCode,
    token,
    type: "sms",
  });
  // miland@alumni.stanford.edu
  if (error || !sessionData || !sessionData.user || !sessionData.user.id) {
    res.error = true;
    res.message = "Invalid token";
    return res;
  } else {
    localStorage.setItem("phoneCredentials", phnWithCode);
    // Check user is already stored
    // const { data }: any = await supabase
    //   .from("user")
    //   .select("*")
    //   .eq("user_id", sessionData.user.id)
    //   .single();

    // if (data && data.username) {
    if (sessionData && sessionData.user && sessionData.user.user_metadata) {
      localStorage.setItem("loggedIn", sessionData.user.user_metadata.username);

      loginSuccess(sessionData.user.user_metadata.username);
    } else {
      res.error = true;
      res.message = "There is no account linked to this phone number";
      return res;
    }
    return res;
  }
}

export async function verifyEmailSignIn(
  email: any,
  token: any,
  loginSuccess: (username: string) => void
) {
  const res = {
    error: false,
    message: "",
  };

  // const { data: sessionData, error } = await supabase.auth.verifyOtp({
  //   phone: phnWithCode,
  //   token,
  //   type: "sms",
  // });

  const { data: sessionData, error } = await supabase.auth.verifyOtp({
    email,
    token,
    type: "email",
  });
  if (error || !sessionData || !sessionData.user || !sessionData.user.id) {
    res.error = true;
    res.message = "Invalid token";
    return res;
  } else {
    localStorage.setItem("phoneCredentials", email);
    // Check user is already stored
    const { data }: any = await supabase
      .from("user")
      .select("*")
      .eq("user_id", sessionData?.user?.id)
      .single();

    if (data && data.username) {
      // if (sessionData && sessionData.user && sessionData.user.user_metadata) {
      localStorage.setItem("loggedIn", data.username);

      loginSuccess(data.username);
    } else {
      res.error = true;
      res.message = "There is no account linked to this email";
      return res;
    }
    return res;
  }
}

export async function verifyPhoneLogin(phnWithCode: any, token: any) {
  let { data, error } = await supabase.auth.verifyOtp({
    phone: phnWithCode,
    token: token,
    type: "sms",
  });
  if (data.user) {
    const { data } = await supabase
      .from("user")
      .select("*")
      .eq("phoneNo", phnWithCode);

    if (data) {
      if (data.length === 0) {
        return false;
      } else {
        const username = data[0].username;
        localStorage.setItem("loggedIn", username);
        return username;
      }
    }
  } else if (error) {
    return "error";
  }
}

export async function activateUser(user_id: string) {
  await supabase
    .from("user")
    .update({ is_active: true })
    .eq("user_id", user_id);
}

export async function fetchUser(
  username: any,
  client: SupabaseClient = supabase
) {
  if (!username) return false;
  let activeSocials: any = [];
  let { data }: any = await client
    .from("user")
    .select("*")
    .eq("username", username);
  
  // Handle null, undefined, or empty array cases
  if (!data || data.length === 0 || !data[0]) {
    return false;
  }
  
  try {
    const user_id = data[0].user_id;
    const name = data[0].name;
    var picture;
    if (data[0].storage_url) {
      picture = data[0].storage_url;
    } else {
      picture = data[0].picture;
    }

    const email = data[0].email;
    const email_verify = data[0].email_verify;
    const phoneNo = data[0].phoneNo;
    const instaLink = data[0].instagram_link;
    const youtubeLink = data[0].youtube_link;
    const amazonLink = data[0].amazon_link;
    const podcastLink = data[0].podcast_link;
    const pinterestLink = data[0].pinterest_link;
    const twitterLink = data[0].twitter_link;
    const instagram_links = data[0].instagram_links;
    const isOnboardingFinished = data[0].is_onboarding_finished;
    const show_mystore = data[0].show_mystore;
    const active_campaign = data[0].active_campaign;
    if (instaLink) {
      activeSocials.push({ term: "instagram", link: instaLink });
    }
    if (youtubeLink) {
      activeSocials.push({ term: "youtube", link: youtubeLink });
    }
    if (amazonLink) {
      activeSocials.push({ term: "amazon", link: amazonLink });
    }
    if (podcastLink) {
      activeSocials.push({ term: "podcast", link: podcastLink });
    }
    if (pinterestLink) {
      activeSocials.push({ term: "pinterest", link: pinterestLink });
    }
    if (twitterLink) {
      activeSocials.push({ term: "twitter", link: twitterLink });
    }
    return {
      name,
      picture,
      email,
      phoneNo,
      instaLink,
      youtubeLink,
      amazonLink,
      podcastLink,
      pinterestLink,
      twitterLink,
      activeSocials,
      user_id,
      instagram_links,
      isOnboardingFinished,
      email_verify,
      show_mystore,
      active_campaign,
    };
  } catch (error) {
    console.error("Error processing user data in fetchUser:", error);
    return false;
  }
}

export async function updatePhoneNo(
  user_id: any,
  username: any,
  phoneNumber: any,
  isMemberPhone: boolean
) {
  try {
    const { data: adminData, error: adminError } =
      await supabase.auth.admin.updateUserById(user_id, {
        phone_confirm: true,
      });

    if (adminError) {
      return { data: null, error: adminError };
    }

    if (isMemberPhone) {
      let { data: user }: any = await supabase
        .from("user")
        .select("*")
        .eq("user_id", `${user_id}`);

      // Use utility functions to handle both old and new structures
      const teamMembersData = user[0].team_members || {};
      const membersArray = extractMembersArray(teamMembersData);
      const seatCount = getSeatCount(teamMembersData);

      // Find and update the specific member
      const teamMember = membersArray.find(
        (member: any) => member.email === username
      );

      if (!teamMember) {
        return { data: null, error: new Error("Team member not found") };
      }

      const updatedMembersArray = membersArray.map((member: any) =>
        member.email === teamMember.email
          ? { ...member, phoneNumber: `${phoneNumber}` }
          : member
      );

      // Rebuild the team_members object with proper structure
      const updatedTeamMembers = rebuildTeamMembersObject(updatedMembersArray, seatCount);

      const { data: updateData, error: updateError } = await supabase
        .from("user")
        .update({ team_members: updatedTeamMembers })
        .eq("user_id", `${user_id}`);

      return { data: updateData, error: updateError };
    } else {
      let { data: user }: any = await supabase
        .from("user")
        .select("*")
        .eq("user_id", `${user_id}`);

      if (user.length > 0) {
        const { data: updateData, error: updateError } = await supabase
          .from("user")
          .update({ phoneNo: `${phoneNumber}` })
          .eq("username", `${username}`);

        return { data: updateData, error: updateError };
      }
    }

    return { data: null, error: new Error("User not found") };
  } catch (error) {
    return { data: null, error };
  }
}

export async function notifyZapierOnboarding(
  username: string,
  email: string,
  fieldName: string,
  oldValue: string,
  newValue: string,
  customerId?: string
) {
  try {
    const API_URL = "https://dev.thesearchbubble.com/";
    let customer_Id;
    let userId: string | null = null;

    if (fieldName == "email") {
      customer_Id = customerId
    }
    else {
      const { data, error } = await supabase
        .from("user")
        .select("stripe_detail,user_id")
        .eq("email", email);

      userId = data?.[0]?.user_id ?? null;
      if (data && data.length > 0 && data[0].stripe_detail) {
        // have different store way of stripe_detail sometime it is a string and sometime it is an object, manage both cases
        let stripeDetail;
        if (typeof data[0].stripe_detail === "string") {
          try {
            stripeDetail = JSON.parse(data[0].stripe_detail);
          } catch {
            stripeDetail = null;
          }
        } else {
          stripeDetail = data[0].stripe_detail;
        }
        customer_Id =
          stripeDetail.customer ||
          stripeDetail.stripe_customer_id ||
          stripeDetail.customer_id || stripeDetail?.subscriptions[0]?.stripe_customer_id ||
          null;
      }


    }

    const requestData = {
      username: username || '',
      email: email || '',
      fieldName: fieldName || '',
      oldValue: oldValue || '',
      newValue: newValue || '',
      customerId: customer_Id || null,
      userId: userId || null,
    };

    // Validate required fields
    if (!username || !email || !fieldName) {
      console.warn('Missing required fields for Zapier notification:', { username, email, fieldName });
      return false;
    }



    const response = await axios.post(
      `${API_URL}api/zapier/field-change`,
      requestData
    );

  } catch (error) {
    console.error("Zapier API error:", error);
    return false;
  }
}

export async function updateName(username: any, name: any) {
  let { data }: any = await supabase
    .from("user")
    .select("*")
    .eq("username", `${username}`);
  if (data) {
    const oldName = data[0].name || "";
    await supabase
      .from("user")
      .update({ name: `${name}` })
      .eq("username", `${username}`);

    // Notify Zapier about the name change
    await notifyZapierOnboarding(username, data[0].email, "name", oldName, name);
  }
}

export async function updateMemberName(
  user_id: any,
  teamMemberEmail: any,
  name: any
) {
  let { data: user }: any = await supabase
    .from("user")
    .select("*")
    .eq("user_id", `${user_id}`);

  // Use utility functions to handle both old and new structures
  const teamMembersData = user[0].team_members || {};
  const membersArray = extractMembersArray(teamMembersData);
  const seatCount = getSeatCount(teamMembersData);

  // Find and update the specific member
  const teamMember = membersArray.find(
    (member: any) => member.email === teamMemberEmail
  );

  if (!teamMember) {
    return { data: null, error: new Error("Team member not found") };
  }

  const updatedMembersArray = membersArray.map((member: any) =>
    member.email === teamMember.email ? { ...member, name: `${name}` } : member
  );

  // Rebuild the team_members object with proper structure
  const updatedTeamMembers = rebuildTeamMembersObject(updatedMembersArray, seatCount);

  const { data: updateData, error: updateError } = await supabase
    .from("user")
    .update({ team_members: updatedTeamMembers })
    .eq("user_id", `${user_id}`);

  return { data: updateData, error: updateError };
}

export async function updateProfileNameDescription(
  username: any,
  newVaule: any
) {
  let { data }: any = await supabase
    .from("user")
    .select("*")
    .eq("username", `${username}`);
  if (data) {
    const { error } = await supabase
      .from("user")
      // Keep both display_name and name in sync so all parts of the app
      // see the latest profile name, regardless of which field they read.
      .update({
        display_name:
          typeof newVaule.name === "string" ? newVaule.name.trim() : newVaule.name,
        // name: newVaule.name,
        description:
          typeof newVaule.description === "string"
            ? newVaule.description.trim()
            : newVaule.description,
      })
      .eq("username", `${username}`);
    if (!error) {
      void markLinkInBioContentEdited(
        data[0]?.user_id,
        username,
        "landing-page",
      );
    }
  }
}

export async function updateUsername(username: string, user_id: any) {
  let { data }: any = await supabase
    .from("user")
    .select("*")
    .eq("user_id", user_id);
  if (data) {
    const oldName = data[0].username || "";
    const { error } = await supabase
      .from("user")
      .update({ username })
      .eq("user_id", user_id);
    if (error) return false;
    await supabase.auth.updateUser({
      data: { username },
    });
    localStorage.setItem("loggedIn", username);
    // Notify Zapier about the name change
    await notifyZapierOnboarding(data[0].username, data[0].email, "username", oldName, username);
  }

  return true;
}
export async function updateEmail(user_id: any, username: any, email: any) {
  try {

    const { data: user, error: authError } = await supabase.auth.admin.updateUserById(
      user_id,
      { email: email }
    );

    if (authError) {
      console.error('Auth update error:', authError);
      throw new Error(
        'This email address is already associated with another account.'
      );
    }

    let { data, error: selectError }: any = await supabase
      .from("user")
      .select("*")
      .eq("user_id", user_id);

    if (selectError) {
      console.error('Select error:', selectError);
      throw selectError;
    }

    if (data && data.length > 0) {
      const oldEmail = data[0].email || "";

      const { data: userData, error: updateError } = await supabase
        .from("user")
        .update({
          email: `${email}`,
          emailSignup: `${email}`,
          email_verify: false,
        })
        .eq("username", `${username}`)
        .select();

      if (updateError) {
        console.error('Update error:', updateError);
        throw updateError;
      }

      // Keep our_sellers.email in sync with the user table. Do not change user_id —
      // that column already references the same user.user_id / auth user.
      const sellerUserId = data[0].user_id || user_id;
      const { error: sellerEmailError } = await supabase
        .from("our_sellers")
        .update({
          email: `${email}`,
          updated_at: new Date().toISOString(),
        })
        .eq("user_id", sellerUserId);

      if (sellerEmailError) {
        console.error("Error updating our_sellers email:", sellerEmailError);
        throw sellerEmailError;
      }

      // // have different store way of stripe_detail sometime it is a string and sometime it is an object, manage both cases
      // let stripeDetail;
      // if (typeof data[0].stripe_detail === "string") {
      //   stripeDetail = JSON.parse(data[0].stripe_detail);
      // } else {
      //   stripeDetail = data[0].stripe_detail;
      // }

      // // Handle null/undefined stripeDetail
      // const customerId = stripeDetail ? (
      //   stripeDetail.customer ||
      //   stripeDetail.stripe_customer_id ||
      //   stripeDetail.customer_id ||
      //   stripeDetail?.subscriptions?.[0]?.stripe_customer_id ||
      //   null
      // ) : null;

      // // Notify Zapier about the email change (don't let this break the email update)
      // try {
      //   await notifyZapierOnboarding(data[0].username, data[0].email, "email", oldEmail, email, customerId);
      // } catch (zapierError) {
      //   await notifyZapierOnboarding(data[0].username, data[0].email, "email", oldEmail, email, "");
      //   console.warn('Zapier notification failed, but email update succeeded:', zapierError);
      //   // Don't throw - email update should still succeed
      // }
    } else {
      console.error('No user data found for user_id:', user_id);
      throw new Error('User not found');
    }
  } catch (error) {
    console.error('Error in updateEmail:', error);
    throw error;
  }
}

function isSameTeamMemberRecord(
  member: any,
  teamMember: any,
  memberId?: string
) {
  if (!member || !teamMember) return false;
  if (memberId && (member.auth_user_id === memberId || member.user_id === memberId)) {
    return true;
  }
  if (teamMember.token && member.token === teamMember.token) {
    return true;
  }
  return (
    String(member.email || "").trim().toLowerCase() ===
    String(teamMember.email || "").trim().toLowerCase()
  );
}

export async function updateMemberEmail(
  user_id: any,
  member_id: any,
  teamMemberEmail: any,
  email: any
) {
  const newEmail = String(email || "").trim().toLowerCase();
  const oldEmail = String(teamMemberEmail || "").trim().toLowerCase();

  if (!user_id || !member_id || !newEmail) {
    return { data: null, error: new Error("Missing member email update details") };
  }

  // Locate the member on the creator row first. If this fails we must not
  // change auth.users, or login and team_members would diverge.
  let { data: user, error: selectError }: any = await supabase
    .from("user")
    .select("*")
    .eq("user_id", `${user_id}`);

  if (selectError) {
    return { data: null, error: selectError };
  }

  const teamMembersData = user[0]?.team_members || {};
  const membersArray = extractMembersArray(teamMembersData);
  const seatCount = getSeatCount(teamMembersData);

  const teamMember =
    findTeamMemberForSession(
      teamMembersData,
      { id: member_id, email: oldEmail },
      [oldEmail]
    ) ||
    membersArray.find(
      (member: any) => String(member?.email || "").trim().toLowerCase() === oldEmail
    );

  if (!teamMember) {
    return { data: null, error: new Error("Team member not found") };
  }

  const { error: authError } = await supabaseAdmin.auth.admin.updateUserById(
    member_id,
    { email: newEmail, email_confirm: true }
  );

  if (authError) {
    return { data: null, error: authError };
  }

  const updatedMembersArray = membersArray.map((member: any) =>
    isSameTeamMemberRecord(member, teamMember, member_id)
      ? {
          ...member,
          email: newEmail,
          auth_user_id: member_id,
          email_verify: false,
        }
      : member
  );

  const updatedTeamMembers = rebuildTeamMembersObject(updatedMembersArray, seatCount);

  const { data: updateData, error: updateError } = await supabase
    .from("user")
    .update({ team_members: updatedTeamMembers })
    .eq("user_id", `${user_id}`);

  if (updateError) {
    return { data: updateData, error: updateError };
  }

  // Best-effort: pick up the new email on the current JWT. Guard matching no
  // longer depends on this, so a refresh failure must not fail the update.
  try {
    await supabase.auth.refreshSession();
  } catch (_e) {
    // ignore
  }

  return { data: updateData, error: null };
}

export async function updateMemberEmailVerification(
  creatorId: string,
  sessionUser: TeamMemberSessionUser,
  verified: boolean
) {
  if (!creatorId) {
    return { data: null, error: new Error("Missing creator id") };
  }

  const { data: creator, error: selectError } = await supabase
    .from("user")
    .select("team_members")
    .eq("user_id", creatorId)
    .single();

  if (selectError) {
    return { data: null, error: selectError };
  }

  const teamMembersData = creator?.team_members || {};
  const membersArray = extractMembersArray(teamMembersData);
  const seatCount = getSeatCount(teamMembersData);
  const teamMember = findTeamMemberForSession(teamMembersData, sessionUser);

  if (!teamMember) {
    return { data: null, error: new Error("Team member not found") };
  }

  const updatedMembersArray = membersArray.map((member: any) =>
    isSameTeamMemberRecord(member, teamMember, sessionUser?.id ? String(sessionUser.id) : undefined)
      ? { ...member, email_verify: verified }
      : member
  );

  const { data, error } = await supabase
    .from("user")
    .update({
      team_members: rebuildTeamMembersObject(updatedMembersArray, seatCount),
    })
    .eq("user_id", creatorId);

  return { data, error };
}

export async function fetchUsername(email: any) {
  const { data } = await supabase.from("user").select("*").eq("email", email);

  if (data) {
    if (data?.length === 0) {
      return false;
    } else {
      const username = data[0].username;
      localStorage.setItem("loggedIn", username);
      return username;
    }
  }
}

export async function fetchIncludedUsername() {
  const { data, error } = await supabase
    .from("user")
    .select("username,user_id")
    .eq("global_view", true);

  if (data) {
    const users: any = [];
    const userIds: any = [];
    data.map((data: any) => {
      users.push(data.username);
      userIds.push(data.user_id);
    });
    return { users, userIds };
  }
}

export async function resetUserPassword(email: any) {
  const { data, error } = await supabase.auth.resetPasswordForEmail(email, {
    redirectTo: `${BROWSABLE_WWW_ORIGIN}/auth/update-password`,
  });

  if (error === null) {
    return { success: true, error: null };
  } else {
    return { success: false, error: error };
  }
}
// export async function updateUserPassword(password: any) {
//   const { data, error } = await supabase.auth.updateUser({
//     password: password,
//   });

//   if (error === null) {
//     return true;
//   } else {
//     return error;
//   }
// }
export async function updateUserPassword(password: string) {
  // Use the client-side updateUser which works with the active recovery session
  const { data, error } = await supabase.auth.updateUser({ password });

  if (error) {
    return error;
  }

  return true;
}
export async function storeDirectInstagramUser(
  user_id: string,
  username: string
) {
  const { error } = await supabase
    .from("user")
    .update({ instagram_username: username })
    .eq("user_id", user_id);
  if (error === null) {
    return true;
  }
  return false;
}

export async function storeLinks(
  user_id: any,
  username: any,
  linkName: any,
  link: any,
  imageLinkUrl: any
) {
  const { data, error }: any = await supabase
    .from("user")
    .select("*")
    .eq("user_id", user_id);
  const completeLink = linkName + ":-" + link + ":-" + imageLinkUrl;
  if (data[0].instagram_links) {
    const addedLink = data[0].instagram_links + "," + completeLink;
    const { error } = await supabase
      .from("user")
      .update({ instagram_links: addedLink })
      .eq("user_id", user_id);
    if (error === null) {
      return true;
    }
    return false;
  } else {
    const { error } = await supabase
      .from("user")
      .update({ instagram_links: completeLink })
      .eq("user_id", user_id);
    if (error === null) {
      return true;
    }
    return false;
  }

  // if(error===null){
  // 	return true
  // }
  // return false
}

export async function updateTiktokToggle(user_id: any, toggle: any) {
  await supabase
    .from("user")
    .update({ is_tiktok_on: toggle })
    .eq("user_id", `${user_id}`);
}
export async function updateTwitterToggle(user_id: any, toggle: any) {
  await supabase
    .from("user")
    .update({ is_twitter_on: toggle })
    .eq("user_id", `${user_id}`);
}
export async function updateYoutubeToggle(user_id: any, toggle: any) {
  await supabase
    .from("user")
    .update({ is_youtube_on: toggle })
    .eq("user_id", `${user_id}`);
}
export async function updateNewsletterToggle(user_id: any, toggle: any) {
  await supabase
    .from("user")
    .update({ is_newsletter_on: toggle })
    .eq("user_id", `${user_id}`);
}
export async function updateInstagramToggle(user_id: any, toggle: any) {
  await supabase
    .from("user")
    .update({ is_instagram_on: toggle })
    .eq("user_id", `${user_id}`);
}
export async function updatePodcastToggle(user_id: any, toggle: any) {
  await supabase
    .from("user")
    .update({ is_podcast_on: toggle })
    .eq("user_id", `${user_id}`);
}
export async function updatePinterestToggle(user_id: any, toggle: any) {
  await supabase
    .from("user")
    .update({ is_pinterest_on: toggle })
    .eq("user_id", `${user_id}`);
}
export async function updateFlowdeskToggle(user_id: any, toggle: any) {
  await supabase
    .from("user")
    .update({ is_flowdesk_on: toggle })
    .eq("user_id", `${user_id}`);
}
export async function updateFlowdeskPopupToggle(user_id: any, toggle: any) {
  await supabase
    .from("user")
    .update({ is_flowdeskpopup_on: toggle })
    .eq("user_id", `${user_id}`);
}
export async function updateFilloutToggle(user_id: any, toggle: any) {
  await supabase
    .from("user")
    .update({ is_fillout_on: toggle })
    .eq("user_id", `${user_id}`);
}

export async function appendPlatformOnboarded(
  params: { userId?: string | null; username?: string | null },
  platform: string
): Promise<void> {
  const platformKey = String(platform || "").trim().toLowerCase();
  const userId = params.userId ? String(params.userId) : undefined;
  const username = params.username ? String(params.username) : undefined;
  if (!platformKey) return;
  if (!userId && !username) return;

  try {
    const lookup = userId
      ? supabase
          .from("user")
          .select("platforms_onboarded")
          .eq("user_id", userId)
          .single()
      : supabase
          .from("user")
          .select("platforms_onboarded")
          .eq("username", username as string)
          .single();

    const { data, error } = await lookup;
    if (error || !data) return;

    const existing = String((data as { platforms_onboarded?: string }).platforms_onboarded || "")
      .split(",")
      .map((entry) => entry.trim().toLowerCase())
      .filter(Boolean);

    if (existing.includes(platformKey)) return;

    const updated = [...existing, platformKey].join(",");
    const updateQuery = userId
      ? supabase.from("user").update({ platforms_onboarded: updated }).eq("user_id", userId)
      : supabase
          .from("user")
          .update({ platforms_onboarded: updated })
          .eq("username", username as string);

    await updateQuery;
  } catch (_error) {
    // Non-blocking: platform connection should still succeed if this fails.
  }
}

export async function updatePlatformToggle(
  user_id: any,
  key: string,
  toggle: any
) {
  await supabase
    .from("user")
    .update({ [`is_${key}_on`]: toggle })
    .eq("user_id", `${user_id}`);
}

export async function deleteInstagram(username: any, user_id: any) { }

export async function deleteYoutube(username: any, user_id: any) {
  const { data, error } = await supabase
    .from("user")
    .update({
      youtube_link: null,
      youtube_channel_id: null,
      youtube_token: null,
      youtube_playlist_id: null,
      show_youtube: false,
      yt_storage_url: "",
      is_youtube_on: false,
    })
    .eq("user_id", user_id);
  const { data: del, error: delError } = await supabase
    .from("content_yt")
    .delete()
    .eq("user_id", user_id);
  const { data: del1, error: del1error } = await supabase
    .from("content_new")
    .delete()
    .eq("user_id", user_id)
    .eq("platform", "youtube");
  const { data: del2, error: del2error } = await supabase
    .from(`${username}`)
    .delete()
    .eq("user_id", user_id)
    .eq("platform", "youtube");
}

export async function deletePodcast(username: any, user_id: any) {
  const { data, error } = await supabase
    .from("user")
    .update({
      podcast_link: null,
      podcast_id: null,
      show_podcast: false,
      is_podcast_on: false,
    })
    .eq("user_id", user_id);
  const { data: del, error: delError } = await supabase
    .from("content_podcast")
    .delete()
    .eq("user_id", user_id);
  const { data: del1, error: del1error } = await supabase
    .from("content_new")
    .delete()
    .eq("user_id", user_id)
    .eq("platform", "podcast");
  const { data: del2, error: del2error } = await supabase
    .from(`${username}`)
    .delete()
    .eq("user_id", user_id)
    .eq("platform", "podcast");
  const { data: list }: any = await supabase.storage
    .from("podcasts")
    .list(`${username}`, { limit: 5000 });
  for (let x of list) {
    await supabase.storage.from("podcasts").remove([`${username}/${x.name}`]);
  }
}

export async function deleteNewsletter(username: any, user_id: any) {
  const { data, error } = await supabase
    .from("user")
    .update({
      newsletter_email: null,
      newsletter_website_link: null,
      show_newsletter: false,
      is_newsletter_on: false,
    })
    .eq("user_id", user_id);
  const { data: del, error: delError } = await supabase
    .from("content_newsletter")
    .delete()
    .eq("user_id", user_id);
  const { data: del1, error: del1error } = await supabase
    .from("content_new")
    .delete()
    .eq("user_id", user_id)
    .eq("platform", "newsletter");
  const { data: del2, error: del2error } = await supabase
    .from(`${username}`)
    .delete()
    .eq("user_id", user_id)
    .eq("platform", "newsletter");
}

export async function deleteTiktok(username: any, user_id: any) {
  const { data, error } = await supabase
    .from("user")
    .update({
      tiktok_user: null,

      show_tiktok: false,
      is_tiktok_on: false,
    })
    .eq("user_id", user_id);
  const { data: del, error: delError } = await supabase
    .from("content_tiktok")
    .delete()
    .eq("user_id", user_id);
  const { data: del1, error: del1error } = await supabase
    .from("content_new")
    .delete()
    .eq("user_id", user_id)
    .eq("platform", "tiktok");
  const { data: del2, error: del2error } = await supabase
    .from(`${username}`)
    .delete()
    .eq("user_id", user_id)
    .eq("platform", "tiktok");
  const { data: list }: any = await supabase.storage
    .from("tiktok")
    .list(`${username}`, { limit: 5000 });
  for (let x of list) {
    await supabase.storage.from("tiktok").remove([`${username}/${x.name}`]);
  }
}

// export async function deleteLinkedIn(username: any, user_id: any) {
//   const { data, error } = await supabase
//     .from("user")
//     .update({
//       tiktok_user: null,

//       show_tiktok: false,
//       is_tiktok_on: false,
//     })
//     .eq("user_id", user_id);
//   const { data: del, error: delError } = await supabase
//     .from("content_linkedin")
//     .delete()
//     .eq("user_id", user_id);
//   const { data: del1, error: del1error } = await supabase
//     .from("content_new")
//     .delete()
//     .eq("user_id", user_id)
//     .eq("platform", "linkedin");
//   const { data: del2, error: del2error } = await supabase
//     .from(`${username}`)
//     .delete()
//     .eq("user_id", user_id)
//     .eq("platform", "linkedin");
//   const { data: list }: any = await supabase.storage
//     .from("linkedin")
//     .list(`${username}`, { limit: 5000 });
//   for (let x of list) {
//     await supabase.storage.from("linkedin").remove([`${username}/${x.name}`]);
//   }
// }

export async function deletePinterest(username: any, user_id: any) {
  const { data, error } = await supabase
    .from("user")
    .update({
      pinterest_user: null,

      show_pinterest: false,
      is_pinterest_on: false,
    })
    .eq("user_id", user_id);
  const { data: del, error: delError } = await supabase
    .from("content_pinterest")
    .delete()
    .eq("user_id", user_id);
  const { data: del1, error: del1error } = await supabase
    .from("content_new")
    .delete()
    .eq("user_id", user_id)
    .eq("platform", "pinterest");
  const { data: del2, error: del2error } = await supabase
    .from(`${username}`)
    .delete()
    .eq("user_id", user_id)
    .eq("platform", "pinterest");
  const { data: list }: any = await supabase.storage
    .from("pinterest_pins")
    .list(`${username}`, { limit: 5000 });
  for (let x of list) {
    await supabase.storage
      .from("pinterest_pins")
      .remove([`${username}/${x.name}`]);
  }
}
export async function deleteFlowdesk(username: any, user_id: any) {
  const { data, error } = await supabase
    .from("user")
    .update({
      flowdesk_user: null,

      show_flowdesk: false,
      is_flowdesk_on: false,
    })
    .eq("user_id", user_id);
}
export async function deleteFlowdeskPopup(username: any, user_id: any) {
  const { data, error } = await supabase
    .from("user")
    .update({
      flowdeskpopup_user: null,

      show_flowdeskpopup: false,
      is_flowdeskpopup_on: false,
    })
    .eq("user_id", user_id);
}
export async function deleteFillout(username: any, user_id: any) {
  const { data, error } = await supabase
    .from("user")
    .update({
      fillout_user: null,

      show_fillout: false,
      is_fillout_on: false,
    })
    .eq("user_id", user_id);
  // const { data: del, error: delError } = await supabase
  //   .from("content_pinterest")
  //   .delete()
  //   .eq("user_id", user_id);
  // const { data: del1, error: del1error } = await supabase
  //   .from("content_new")
  //   .delete()
  //   .eq("user_id", user_id)
  //   .eq("platform", "pinterest");
  // const { data: del2, error: del2error } = await supabase
  //   .from(`${username}`)
  //   .delete()
  //   .eq("user_id", user_id)
  //   .eq("platform", "pinterest");
  // const { data: list }: any = await supabase.storage
  //   .from("pinterest_pins")
  //   .list(`${username}`, { limit: 5000 });
  // for (let x of list) {
  //   await supabase.storage
  //     .from("pinterest_pins")
  //     .remove([`${username}/${x.name}`]);
  // }
}

export async function changeSearchBarText(user_id: any, text: any) {
  const { data, error } = await supabase
    .from("user")
    .update({ search_bar_text: text })
    .eq("user_id", user_id);
  if (!error) {
    void markLinkInBioContentEdited(user_id, null, "landing-page");
  }
}
export async function reorderSocialLinks(
  user_id: any,
  actual: any,
  newArray: any,
  length: any
) {
  const actualOrder = actual?.split(",");
  const reorderedArray = [
    ...newArray.filter((item: any) => actualOrder.includes(item)), // Items in the initial order that are also in the actual order
    ...actualOrder.filter((item: any) => !newArray.includes(item)), // Items in the actual order that are not in the initial order
  ];
  const { data, error } = await supabase
    .from("user")
    .update({ social_links_order: reorderedArray.toString() })
    .eq("user_id", user_id);
  if (!error) {
    void markLinkInBioContentEdited(user_id, null, "landing-page");
  }
}

// Add this new function to delete expired users from Supabase auth
export async function deleteExpiredUser(
  email: string,
  creatorId: string,
  memberId: string,
  type?: string
) {
  try {
    //  delete user from creator's team_members
    const { data: creatorData, error: fetchError } = await supabase
      .from("user")
      .select("team_members")
      .eq("user_id", creatorId)
      .single();

    // Use utility functions to handle both old and new structures
    const teamMembersData = creatorData?.team_members || {};
    const membersArray = extractMembersArray(teamMembersData);
    const currentSeatCount = getSeatCount(teamMembersData);

    const memberToDelete = membersArray.find(
      (member: any) => member.email === email
    );
    // get the id of the user to delete using email
    if (memberToDelete) {
      // delete user from supabase auth
      // sign out the memberID before deleting if he is logged in somewhere, if the current user is the member to delete, then sign out the current user
      if (memberId != undefined && memberId !== creatorId) {
        await supabase.auth.signOut();
      }
      // delete user from supabase auth
      if (memberId != undefined && memberId !== creatorId) {
        const { data: authData, error: authError } =
          await supabase.auth.admin.deleteUser(memberId);
        if (authError) {
        }
      } else {
        // get all the user from supabase auth through email and than delete the user
        const { data: userData, error: userError } =
          await supabase.auth.admin.listUsers();
        const user = userData?.users?.find((user: any) => user.email === email);
        if (user) {
          const { data: authData, error: authError } =
            await supabase.auth.admin.deleteUser(user.id);
        }
      }
      // remove member from creator's team_members while preserving seat_count
      const filteredMembers = membersArray.filter(
        (member: any) => member.email !== email
      );

      // Rebuild the team_members object with proper structure
      const updatedTeamMembers = rebuildTeamMembersObject(filteredMembers, currentSeatCount);

      const { data: updatedMembers, error: updateError } = await supabase
        .from("user")
        .update({
          team_members: updatedTeamMembers,
        })
        .eq("user_id", creatorId);
      if (updateError) {
      } else {
        return true;
      }
      // if (deleteError) {
      // }
      // else{
      //   return true;
      // }
    }

    if (fetchError) {
      return false;
    }
    return true;
  } catch (error) {
    return false;
  }
}

export const inviteTeamMember = async (
  creatorId: string,
  email: string,
  role: string,
  isResend: boolean = false
) => {
  try {
    // Check if email is admin
    if (email === "admin@searchbubble.com") {
      return { error: "Invalid email address" };
    }

    // Check if member already exists in creator's team_members
    const { data: creatorData, error: fetchError } = await supabase
      .from("user")
      .select("team_members")
      .eq("user_id", creatorId)
      .single();

    if (fetchError) return { error: fetchError.message };

    // Use utility functions to handle both old and new structures
    const teamMembersData = creatorData?.team_members || {};
    const existingMembers = extractMembersArray(teamMembersData);
    const currentSeatCount = getSeatCount(teamMembersData);

    // Check existing member status - check for active members and valid pending invitations
    const activeMember = existingMembers.find(
      (member: any) => member.email === email && member.status === "active"
    );
    if (activeMember) {
      return { error: "This user is already a team member" };
    }

    const pendingMember = existingMembers.find(
      (member: any) => member.email === email && member.status === "pending" && new Date(member.expires_at) > new Date()
    );
    if (pendingMember && !isResend) {
      return { error: "This email already has a pending invitation" };
    }

    // Generate invitation token
    const token = crypto.randomUUID();

    // Add member to team_members with expiry
    const newMember = {
      email,
      creator_id: creatorId,
      role,
      token,
      status: "pending",
      created_at: new Date().toISOString(),
      expires_at: new Date(Date.now() + 48 * 60 * 60 * 1000).toISOString(), // 48 hours from now
    };

    // Update database with new invitation
    const updatedMembers = isResend
      ? existingMembers.map((m: any) => 
          (m.email === email && m.status === "pending") ? newMember : m
        )
      : [...existingMembers, newMember];

    // Rebuild the team_members object with proper structure
    const teamMembersWithSeatCount = rebuildTeamMembersObject(updatedMembers, currentSeatCount);

    const { error: updateError } = await supabase
      .from("user")
      .update({
        team_members: teamMembersWithSeatCount,
      })
      .eq("user_id", creatorId);

    if (updateError) return { error: updateError.message };

    // Send invitation email via admin client so the browser session (creator) is not touched.
    const { error: inviteError } = await supabaseAdmin.auth.admin.inviteUserByEmail(
      email,
      {
        redirectTo: `${getAuthRedirectOrigin()}/accept-invite`,
        data: {
          invitation_token: token,
          creator_id: creatorId,
        },
      }
    );

    if (inviteError) return { error: inviteError.message };

    return {
      message: isResend
        ? "Invitation resent successfully!"
        : "Invitation sent successfully!",
    };
  } catch (error: any) {
    return { error: error.message };
  }
};

export const resendInvitation = async (email: string, creatorId: string) => {
  try {
    const { data: creatorData, error: fetchError } = await supabase
      .from("user")
      .select("team_members")
      .eq("user_id", creatorId)
      .single();
    if (fetchError) return { error: fetchError.message };
    // Use utility functions to handle both old and new structures
    const teamMembersData = creatorData?.team_members || {};
    const existingMembers = extractMembersArray(teamMembersData);
    const currentSeatCount = getSeatCount(teamMembersData);

    const existingMember = existingMembers.find(
      (member: any) => member.email === email
    );
    if (existingMember) {
      if (existingMember.status === "active") {
        return { error: "This user is already a team member" };
      }
      // if (new Date(existingMember.expires_at) < new Date()) {
      //   return { error: "This email already has a pending invitation" };
      // }
      // Remove prior invited auth user (if any) using admin client — do not use the session client.
      const { data: emailRows, error: emailRpcError } = await supabase.rpc(
        "check_email_exists_with_id",
        { p_email: email }
      );
      if (emailRpcError) {
        return { error: emailRpcError.message };
      }
      const rows = emailRows as unknown;
      let authUserIdToDelete: string | null = null;
      if (Array.isArray(rows) && rows.length > 0 && (rows[0] as any)?.auth_user_id) {
        authUserIdToDelete = String((rows[0] as any).auth_user_id);
      } else if (rows && typeof rows === "object" && "auth_user_id" in (rows as object)) {
        const id = (rows as { auth_user_id?: string }).auth_user_id;
        authUserIdToDelete = id ? String(id) : null;
      }
      if (authUserIdToDelete) {
        const { error: authError } = await supabaseAdmin.auth.admin.deleteUser(authUserIdToDelete);
        if (authError) {
          return { error: authError.message };
        }
      }
      // update member from creator's team_members
      // Generate invitation token
      const token = crypto.randomUUID();

      // find the member in the existing members and update the token and expires_at
      const updatedMember = existingMembers.find(
        (member: any) => member.email === email
      );
      if (updatedMember) {
        updatedMember.token = token;
        updatedMember.expires_at = new Date(
          Date.now() + 48 * 60 * 60 * 1000
        ).toISOString(); // 48 hours from now
      }

      // Preserve seat_count in the updated team_members object
      const updatedMembersArray = existingMembers.map((member: any) =>
        member.email === email && member.status === "pending" ? updatedMember : member
      );

      // Rebuild the team_members object with proper structure
      const updatedTeamMembers = rebuildTeamMembersObject(updatedMembersArray, currentSeatCount);

      const { data: updatedMembers, error: updateError } = await supabase
        .from("user")
        .update({
          team_members: updatedTeamMembers,
        })
        .eq("user_id", creatorId);
      if (updateError) {
        return { error: updateError.message };
      }

      // resend the invitation (admin client only — avoids logging out the creator)
      const { error: inviteError } =
        await supabaseAdmin.auth.admin.inviteUserByEmail(email, {
          redirectTo: `${getAuthRedirectOrigin()}/accept-invite`,
          data: {
            invitation_token: token,
            creator_id: creatorId,
          },
        });
      if (inviteError) {
        return { error: inviteError.message };
      }
      return { message: "Invitation resent successfully!" };
    }
  } catch (error: any) {
    return { error: error.message };
  }
};

export const cleanupDuplicateMembers = async (creatorId: string) => {
  try {
    // Get creator's team members data
    const { data: creatorData, error: fetchError } = await supabase
      .from("user")
      .select("team_members")
      .eq("user_id", creatorId)
      .single();

    if (fetchError) return { error: fetchError.message };

    const teamMembersData = creatorData?.team_members || {};
    const existingMembers = extractMembersArray(teamMembersData);
    const currentSeatCount = getSeatCount(teamMembersData);

    // Group members by email
    const membersByEmail: { [email: string]: any[] } = {};
    existingMembers.forEach((member: any) => {
      if (!membersByEmail[member.email]) {
        membersByEmail[member.email] = [];
      }
      membersByEmail[member.email].push(member);
    });

    // Clean up duplicates - keep only the most recent record for each email
    const cleanedMembers: any[] = [];
    Object.keys(membersByEmail).forEach(email => {
      const emailMembers = membersByEmail[email];
      if (emailMembers.length === 1) {
        // No duplicates, keep as is
        cleanedMembers.push(emailMembers[0]);
      } else {
        // Multiple entries for same email - keep the most recent one
        const sortedMembers = emailMembers.sort((a: any, b: any) => 
          new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
        );
        cleanedMembers.push(sortedMembers[0]);
      }
    });

    // Rebuild the team_members object with cleaned data
    const cleanedTeamMembers = rebuildTeamMembersObject(cleanedMembers, currentSeatCount);

    const { error: updateError } = await supabase
      .from("user")
      .update({
        team_members: cleanedTeamMembers,
      })
      .eq("user_id", creatorId);

    if (updateError) {
      return { error: updateError.message };
    }

    return { 
      message: "Duplicates cleaned successfully!", 
      removedCount: existingMembers.length - cleanedMembers.length 
    };
  } catch (error: any) {
    return { error: error.message };
  }
};

export const cancelInvitation = async (email: string, creatorId: string) => {
  try {
    // Get creator's team members data
    const { data: creatorData, error: fetchError } = await supabase
      .from("user")
      .select("team_members")
      .eq("user_id", creatorId)
      .single();

    if (fetchError) return { error: fetchError.message };

    // Use utility functions to handle both old and new structures
    const teamMembersData = creatorData?.team_members || {};
    const existingMembers = extractMembersArray(teamMembersData);
    const currentSeatCount = getSeatCount(teamMembersData);

    // Find the member to cancel - get the most recent pending invitation for this email
    const pendingMembers = existingMembers.filter(
      (member: any) => member.email === email && member.status === "pending"
    );
    
    // Sort by created_at to get the most recent one
    const memberToCancel = pendingMembers.sort((a: any, b: any) => 
      new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
    )[0];

  

    if (!memberToCancel) {
      return { error: "Member not found" };
    }

    if (memberToCancel.status !== "pending") {
      return { error: "Can only cancel pending invitations" };
    }

    // 1. Expire the token by setting expires_at to past date
    const expiredMember = {
      ...memberToCancel,
      status: "canceled",
      expires_at: new Date(Date.now() - 1000).toISOString(), // Set to past date to expire token
      canceled_at: new Date().toISOString() // Add timestamp when canceled
    };

    // 2. Delete user from Supabase Auth if they exist
    const { data: userData, error: userError } = await supabase.auth.admin.listUsers();
    const user = userData?.users?.find((user: any) => user.email === email);
    if (user) {
      const { error: authError } = await supabase.auth.admin.deleteUser(user.id);
      if (authError) {
        return { error: authError.message };
      }
    }

    // 3. Update the member status to 'canceled' in database (don't remove from team_members)
    const updatedMembersArray = existingMembers.map((member: any) =>
      member.email === email && member.token === memberToCancel.token && member.status === "pending" ? expiredMember : member
    );

    // Rebuild the team_members object with proper structure
    const updatedTeamMembers = rebuildTeamMembersObject(updatedMembersArray, currentSeatCount);

    const { error: updateError } = await supabase
      .from("user")
      .update({
        team_members: updatedTeamMembers,
      })
      .eq("user_id", creatorId);

    if (updateError) {
      return { error: updateError.message };
    }

    return { message: "Invitation canceled successfully!" };
  } catch (error: any) {
    return { error: error.message };
  }
};

// async function cleanupExpiredInvitations(
//   creatorId: string,
//   teamMembers: any[]
// ) {
//   // Filter out expired pending invitations and delete expired users
//   const validMembers = teamMembers.filter((member: any) => {
//     const isExpired = new Date(member.expires_at) < new Date();
//     if (isExpired && member.status === "pending") {
//       // Delete expired user from Supabase auth
//       deleteExpiredUser(member.email, creatorId);
//     }
//     return !(isExpired && member.status === "pending");
//   });

//   // Update the database with cleaned up members list
//   if (validMembers.length !== teamMembers.length) {
//     const { error } = await supabase
//       .from("user")
//       .update({ team_members: validMembers })
//       .eq("user_id", creatorId);

//     if (error) {
//     }
//   }
//   return validMembers;
// }

export async function verifyInvitation(token: string) {
  try {
    // Find the creator who has this invitation token
    const { data: creators, error: fetchError } = await supabase.rpc(
      "find_team_member_by_token",
      { search_token: token }
    );

    if (fetchError) {
      throw fetchError;
    }

    if (!creators || creators.length === 0) {
      return { error: true, message: "Invalid invitation token" };
    }

    const creator = creators[0];

    // // Clean up expired invitations
    // const updatedMembers = await cleanupExpiredInvitations(
    //   creator.user_id,
    //   creator.team_members
    // );

    // Use utility functions to handle both old and new structures
    const teamMembersData = creator.team_members || {};
    const membersArray = extractMembersArray(teamMembersData);

    const member = membersArray.find((m: any) => m.token === token);

    if (!member) {
      return { error: true, message: "Invalid or expired invitation token" };
    }

    // Check if invitation has expired
    if (new Date(member.expires_at) < new Date()) {
      return { error: true, message: "Invitation has expired" };
    }

    // Check if invitation is already used
    if (member.status === "active") {
      return { error: true, message: "Invitation already used" };
    }

    return {
      error: false,
      isValid: true,
      creatorId: member.creator_id,
      email: member.email,
    };
  } catch (error: any) {
    return { error: true, message: error.message };
  }
}

export async function acceptInvitation(
  token: string,
  password: string,
  email: string,
  creatorId: any,
  name: string,
  phoneNumber: string
) {
  try {
    // First get the invited user's ID
    // const {
    //   data: { users },
    //   error: getUserError,
    // } = await supabase.auth.admin.listUsers();

    // if (getUserError) {
    //   throw getUserError;
    // }

    // const invitedUser = users.find((user: any) => user.email === email);

    const { data: emailRows, error: emailRpcError } = await supabase.rpc(
      "check_email_exists_with_id",
      { p_email: email }
    );

    if (emailRpcError) {
      throw emailRpcError;
    }

    const rows = emailRows as unknown;
    let authUserId: string | null = null;
    if (Array.isArray(rows) && rows.length > 0 && rows[0]?.auth_user_id) {
      authUserId = String(rows[0].auth_user_id);
    } else if (rows && typeof rows === 'object' && 'auth_user_id' in (rows as object)) {
      const id = (rows as { auth_user_id?: string }).auth_user_id;
      authUserId = id ? String(id) : null;
    }

    if (authUserId) {
      const { error: userError } = await supabaseAdmin.auth.admin.updateUserById(authUserId, {
        password: password,
      });
      if (userError) {
        throw userError;
      }
    } else {
      throw new Error(
        "Could not find the invited account in authentication. Ask your team admin to resend the invitation."
      );
    }

    // Update member status to active and add name/phone to team_members
    const { data: creator, error: fetchError } = await supabase
      .from("user")
      .select("team_members")
      .eq("user_id", creatorId)
      .single();

    if (fetchError) {
      throw fetchError;
    }

    // Use utility functions to handle both old and new structures
    const teamMembersData = creator.team_members || {};
    const membersArray = extractMembersArray(teamMembersData);
    const currentSeatCount = getSeatCount(teamMembersData);

    const updatedMembers = membersArray.map((member: any) => {
      if (member.token === token) {
        return {
          ...member,
          status: "active",
          name: name,
          phoneNumber: phoneNumber,
          ...(authUserId ? { auth_user_id: authUserId } : {}),
        };
      }
      return member;
    });

    // Rebuild the team_members object with proper structure
    const updatedTeamMembers = rebuildTeamMembersObject(updatedMembers, currentSeatCount);

    const { error: updateError } = await supabase
      .from("user")
      .update({ team_members: updatedTeamMembers })
      .eq("user_id", creatorId);

    if (updateError) {
      throw updateError;
    }

    // Try to sign in with the new credentials to verify everything worked
    const { data: signInData, error: signInError } =
      await supabase.auth.signInWithPassword({
        email: email,
        password: password,
      });

    if (signInError) {
      throw signInError;
    }

    return {
      error: false,
      message: "Account created successfully. You can now log in.",
    };
  } catch (error: any) {
    return { error: true, message: error.message };
  }
}

// Utility functions to handle both old and new team_members structures
export const extractMembersArray = (teamMembersData: any): any[] => {
  if (!teamMembersData) return [];

  // Handle old array format
  if (Array.isArray(teamMembersData)) {
    return teamMembersData;
  }

  // Handle new object format with seat_count
  return Object.keys(teamMembersData)
    .filter(key => key !== 'seat_count')
    .map(key => teamMembersData[key])
    .filter(member => member && typeof member === 'object' && member.email);
};

export type TeamMemberSessionUser = {
  id?: string | null;
  email?: string | null;
  user_metadata?: Record<string, any> | null;
} | null | undefined;

/**
 * Identify a team member by stable auth identity first (auth user id / invite
 * token), then fall back to email. Email alone is not enough during an email
 * change: team_members is updated before the JWT email refreshes.
 */
export function findTeamMemberForSession(
  teamMembersData: any,
  sessionUser: TeamMemberSessionUser,
  additionalEmails: Array<string | null | undefined> = []
) {
  const members = extractMembersArray(teamMembersData);
  if (!members.length || !sessionUser) return undefined;

  const sessionId = sessionUser.id ? String(sessionUser.id) : "";
  const invitationToken = String(
    sessionUser.user_metadata?.invitation_token || ""
  ).trim();
  const emails = new Set(
    [sessionUser.email, ...additionalEmails]
      .map((value) => String(value || "").trim().toLowerCase())
      .filter(Boolean)
  );

  return members.find((member: any) => {
    if (!member || typeof member !== "object") return false;
    if (
      sessionId &&
      (String(member.auth_user_id || "") === sessionId ||
        String(member.user_id || "") === sessionId)
    ) {
      return true;
    }
    if (invitationToken && String(member.token || "") === invitationToken) {
      return true;
    }
    const memberEmail = String(member.email || "").trim().toLowerCase();
    return Boolean(memberEmail && emails.has(memberEmail));
  });
}

export const getSeatCount = (teamMembersData: any): number => {
  if (!teamMembersData) return 1;

  // Handle old array format
  if (Array.isArray(teamMembersData)) {
    // For backwards compatibility, assume 1 seat if it's an array
    return 1;
  }

  // Handle new object format with seat_count
  return teamMembersData?.seat_count || 1;
};

export const rebuildTeamMembersObject = (membersArray: any[], seatCount: number = 1): any => {
  const result: any = {
    seat_count: seatCount
  };

  // Add members back with proper indexing
  membersArray.forEach((member: any, index: number) => {
    result[index.toString()] = member;
  });

  return result;
};

// Function to increment seat count after successful payment
export const incrementSeatCount = async (creatorId: string) => {
  try {
    const { data: creatorData, error: fetchError } = await supabase
      .from("user")
      .select("team_members")
      .eq("user_id", creatorId)
      .single();

    if (fetchError) return { error: fetchError.message };

    const currentSeatCount = creatorData?.team_members?.seat_count || 1;
    const newSeatCount = currentSeatCount + 1;

    // Update seat count in team_members object
    const updatedTeamMembers = {
      ...creatorData?.team_members,
      seat_count: newSeatCount
    };

    const { error: updateError } = await supabase
      .from("user")
      .update({
        team_members: updatedTeamMembers,
      })
      .eq("user_id", creatorId);

    if (updateError) return { error: updateError.message };

    return { success: true, newSeatCount };
  } catch (error: any) {
    return { error: error.message };
  }
};

// Update seat count while keeping data consistent and guarding against invalid reductions
export const updateSeatCount = async (
  creatorId: string,
  newSeatCount: number
) => {
  try {
    const { data: creatorData, error: fetchError } = await supabase
      .from("user")
      .select("team_members")
      .eq("user_id", creatorId)
      .single();

    if (fetchError) return { error: fetchError.message };

    const teamMembersData = creatorData?.team_members || {};
    const membersArray = extractMembersArray(teamMembersData);
    const currentSeatCount = getSeatCount(teamMembersData);
    const totals = calculateSeatTotals(currentSeatCount, membersArray);
    const normalizedNext = Math.max(newSeatCount, 1);

    if (normalizedNext < totals.usedSeats) {
      return {
        error: `You have ${totals.usedSeats} active members, so you can’t reduce seats below ${totals.usedSeats}.`,
      };
    }

    const updatedTeamMembers = rebuildTeamMembersObject(
      membersArray,
      normalizedNext
    );

    const { error: updateError } = await supabase
      .from("user")
      .update({
        team_members: updatedTeamMembers,
      })
      .eq("user_id", creatorId);

    if (updateError) return { error: updateError.message };

    const nextTotals = calculateSeatTotals(normalizedNext, membersArray);

    return {
      success: true,
      totalSeats: nextTotals.totalSeats,
      usedSeats: nextTotals.usedSeats,
      freeSeats: nextTotals.freeSeats,
      availableSeats: nextTotals.freeSeats,
    };
  } catch (error: any) {
    return { error: error.message };
  }
};

// Function to get current seat count and available seats
export const getSeatInfo = async (creatorId: string) => {
  try {
    const { data: creatorData, error: fetchError } = await supabase
      .from("user")
      .select("team_members")
      .eq("user_id", creatorId)
      .single();

    if (fetchError) return { error: fetchError.message };

    const teamMembersData = creatorData?.team_members || {};
    const membersArray = extractMembersArray(teamMembersData);
    const seatCount = getSeatCount(teamMembersData);
    const totals = calculateSeatTotals(seatCount, membersArray);

    return {
      totalSeats: totals.totalSeats,
      usedSeats: totals.usedSeats,
      availableSeats: totals.freeSeats,
      freeSeats: totals.freeSeats,
    };
  } catch (error: any) {
    return { error: error.message };
  }
};

export async function updateFirstRedirect(username: string) {
  try {
    await supabase
      .from("user")
      .update({ is_first_redirect: true })
      .eq("username", username);
    return true;
  } catch (error) {
    return false;
  }
}

export async function updatePageReady(username: string) {
  try {
    await supabase
      .from("user")
      .update({ is_page_ready: false })
      .eq("username", username);
    return true;
  } catch (error) {
    return false;
  }
}



export async function removeYoutubeChannel(username: any) {
  await supabase
    .from("user")
    .update({
      // youtube_playlist_id:
      //   validationResponse?.data?.channelInfo?.uploadPlaylistId,
      // youtube_channel_id: validationResponse?.data?.channelInfo?.channelId
      // ,
      youtube_playlist_id:
        "",
      youtube_channel_id:
        "",
      youtube_username: "",
      is_youtube_on: false,
    })
    .eq("username", username);
}

export async function createTeamMemberSession(userId: string, email: string) {

  const API_URL = StaticVariables().API_BASE;
  const testMode = checkTestEmail(email) || isStripeTestModeSync();

  const response = await fetch(`${API_URL}/api/stripe/create-team-upgrade-session`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',  // ← ADD THIS LINE
    },
    body: JSON.stringify({ userId, email, domain: window.location.origin, testMode }),
  });
  const data = await response.json();
  return data;

}

export async function fetchUserDesign(username: any) {
  let { data, error }: any = await supabase
    .from("user")
    .select(
      "font_family,background_style,button_background,button_text,button_border,text_color,social_icon_color,template_name"
    )
    .eq("username", username);
  
  if (error || !data || data.length === 0) {
    return {
      font_family: "",
      background_style: "",
      button_background: "",
      button_text: "",
      button_border: "",
      text_color: "",
      social_icon_color: "",
      template_name: "",
    };
  }
  
  return {
    font_family: data[0].font_family || "",
    background_style: data[0].background_style || "",
    button_background: data[0].button_background || "",
    button_text: data[0].button_text || "",
    button_border: data[0].button_border || "",
    text_color: data[0].text_color || "",
    social_icon_color: data[0].social_icon_color || "",
    template_name: data[0].template_name || "",
  }
}

export async function updateUserDesign(
  user_id: string,
  designData: {
    primary_font_family?: string,
    secondary_font_family?: string,
    font_family?: string;
    background_style?: string;
    button_background?: string;
    button_text?: string;
    button_border?: string;
    text_color?: string;
    social_icon_color?: string;
    template_name?: string;
    card_style?: string;
    custom_colors?: {
      active?: {
        primary?: string;
        secondary?: string;
        tertiary?: string;
        forth?: string;
      };
    } | null;
  }
) {
  try {
    const { data, error } = await supabase
      .from("user")
      .update(designData)
      .eq("user_id", user_id);

    if (error) {
      throw error;
    }

    void markLinkInBioContentEdited(user_id, null, "landing-page");
    return data;
  } catch (error) {
    console.error("Error updating user design:", error);
    throw error;
  }
}

export async function updateUserCustomColors(
  user_id: string,
  active: {
    primary?: string;
    secondary?: string;
    tertiary?: string;
    forth?: string;
  }
) {
  try {
    const { data, error } = await supabase
      .from("user")
      .update({ custom_colors: { active } })
      .eq("user_id", user_id);

    if (error) {
      throw error;
    }

    void markLinkInBioContentEdited(user_id, null, "landing-page");
    return data;
  } catch (error) {
    console.error("Error updating user custom colors:", error);
    throw error;
  }
}

export async function verifyTeamMemberSession(
  sessionId: string,
  userId: string,
  email: string
): Promise<unknown> {
  const { API_BASE } = StaticVariables();
  const base = String(API_BASE).replace(/\/+$/, "");
  const testMode = checkTestEmail(email) || isStripeTestModeSync();

  const response = await fetch(`${base}/api/stripe/verify-team-upgrade-payment`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ sessionId, userId, email, testMode }),
  });

  let payload: Record<string, unknown> = {};
  try {
    payload = (await response.json()) as Record<string, unknown>;
  } catch {
    payload = {};
  }

  if (!response.ok) {
    const message =
      (typeof payload.message === "string" && payload.message) ||
      (typeof payload.error === "string" && payload.error) ||
      `Payment verification failed (${response.status})`;
    throw new Error(message);
  }

  if (payload.success === false) {
    const message =
      (typeof payload.message === "string" && payload.message) ||
      "Payment verification failed";
    throw new Error(message);
  }

  return payload.data !== undefined ? payload.data : payload;
}